import mountain from '../images/mountain-small.jpg';
import { ReactComponent as Arrow } from '../images/arrow.svg';
import mountainCircle1 from '../images/mountain-circle1.png';
import mountainCircle2 from '../images/mountain-circle2.png';
import mountainCircle3 from '../images/mountain-circle3.png';

const Mountain = () => (
  <>
    <div className="container container-small text-center">
      <h2 className="h1 text-uppercase" id="heading-2">
        How The Game Works:
      </h2>
    </div>
    <div className="container position-relative z-1">
      <img src={mountain} alt="Gem Mountain" className="img-fluid img-shadow" />
      <Arrow className="arrow-corner position-absolute start-0 top-100 ms-2 mt-n4" />
    </div>
    <div className="section-yellow text-center edge--top edge--bottom--reverse">
      <div className="container container-small">
        <p className="h2">
          This is Gem Mountain. Your mission is to get to the top. There are three levels to the
          mountain; you move up a level by completing challenges.
        </p>
      </div>
      <div className="container">
        <div id="mountain-circle-wrapper">
          <img
            src={mountainCircle1}
            alt="1"
            className="rounded-circle img-shadow position-absolute top-50 start-0 translate-middle-y"
          />
          <img
            src={mountainCircle2}
            alt="2"
            className="rounded-circle img-shadow position-absolute top-50 start-50 translate-middle"
          />
          <img
            src={mountainCircle3}
            alt="3"
            className="rounded-circle img-shadow position-absolute top-50 end-0 translate-middle-y"
          />
        </div>
      </div>
    </div>
  </>
);

export default Mountain;
